/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the MarketplaceFilterSettingsGroupedDTO interface.
 */
export function instanceOfMarketplaceFilterSettingsGroupedDTO(value) {
    return true;
}
export function MarketplaceFilterSettingsGroupedDTOFromJSON(json) {
    return MarketplaceFilterSettingsGroupedDTOFromJSONTyped(json, false);
}
export function MarketplaceFilterSettingsGroupedDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'source': json['source'] == null ? undefined : json['source'],
        'target': json['target'] == null ? undefined : json['target'],
    };
}
export function MarketplaceFilterSettingsGroupedDTOToJSON(json) {
    return MarketplaceFilterSettingsGroupedDTOToJSONTyped(json, false);
}
export function MarketplaceFilterSettingsGroupedDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'source': value['source'],
        'target': value['target'],
    };
}
